module.exports = __webpack_public_path__ + "img/index-single.8a39d0fa.svg";